import type {MaterialStorage} from '@domain/material-storage'
import {
  DepartmentNode,
  EquipmentNode,
  UpmDepartmentOrEquipmentType,
  UpmMaterialStorage,
  Asset
} from '@hconnect/common/types'

import {getDepartmentOrEquipmentType} from './getDepartmentOrEquipmentType'

export const isAssetEnabledForPlanning = (
  enabledForPlanningItem?: Asset | UpmMaterialStorage
): enabledForPlanningItem is Asset =>
  (enabledForPlanningItem as Asset)?.stopCoefficient !== undefined

export const isStorageEnabledForPlanning = (
  enabledForPlanningItem?: Asset | UpmMaterialStorage
): enabledForPlanningItem is UpmMaterialStorage =>
  (enabledForPlanningItem as UpmMaterialStorage)?.capacity !== undefined

/**
 * This helper function is used to fetch enabled for planning item (either asset or material storage)
 * @param node - UPM tree node
 * @param assets - list of assets present in plant
 * @param materialStorages - list of material storages present in plant
 * @returns either Asset or MaterialStorage if found, otherwise undefined
 */
export const getEnabledForPlanningItem = (
  node: DepartmentNode | EquipmentNode,
  assets: Asset[],
  materialStorages: MaterialStorage[]
) => {
  const departmentOrEquipmentType = getDepartmentOrEquipmentType(node)

  if (departmentOrEquipmentType === UpmDepartmentOrEquipmentType.MaterialStorage) {
    return materialStorages.find((storage) => storage.upmId === node.upmId)
  }

  return assets.find((asset) => asset.upmId === node.upmId)
}
